import { createBrowserRouter } from 'react-router';

import appRoutes from 'src/app/ui/routes';

export const router = createBrowserRouter(appRoutes);
